<template>
  <div
    class="card-main"
    @click="onClick"
    @mouseover="focusOn"
    @mouseleave="focusOut"
  >
    <div class="focus-ring" v-show="isfocusOn && mouseActivated"></div>
    <img class="cover-img" v-lazy="cardData.logo" />
    <!-- <img class="cover-img" :src="cardData.logo" /> -->
    <div class="card-text">
      <p class="name singleline">{{ cardData.name }}</p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isActiveVue: true,
      isfocusOn: false,
    };
  },

  props: ["cardData", "isFocusedLine"],

  computed: {
    mouseActivated() {
      return this.$store.getters.mouseActivated;
    },
  },

  methods: {
    onClick() {
      if (this.isfocusOn) {
        this.clickCard();
      }
    },
    clickCard() {
      this.$router.push({
        name: "league2nd",
        params: {
          name: this.cardData.name,
          gameTypeId: this.cardData.gameTypeId,
          leagueId: this.cardData.id,
          t: new Date().getTime(),
        },
      });
      this.focusOut();
    },
    focusOn() {
      if (this.isFocusedLine) {
        this.isfocusOn = true;
      }
    },
    focusOut() {
      this.isfocusOn = false;
    },
  },
};
</script>

<style scoped>
p {
  line-height: 10px;
}
.card-main {
  position: relative;
  display: inline-block;
  width: 250px;
  height: 320px;
  margin-right: 20px;
  background-color: #1e1e1e;
}
.focus-ring {
  position: absolute;
  left: -5px;
  top: -4px;
  width: 250px;
  height: 320px;
  border: solid 4px #eeeeee;
  z-index: 5;
}
.cover-img {
  width: 196px;
  height: 196px;
  margin: 27px;
}
.card-text {
  display: inline-block;
  width: 250px;
  height: 24px;
  /* margin: 16px 0 0; */
  font-size: 24px;
  text-align: center;
  color: #a0a0a0;
}
.name {
  width: 230px;
  height: 24px;
  margin: 0 auto;
  line-height: 24px;
  overflow: hidden;
  white-space: nowrap;
}

@media all and (min-width:0px) and (max-width:1280px){
  .card-main {
    position: relative;
    display: inline-block;
    width: 168px;
    height: 210px;
    margin-right: 16px;
    background-color: #1e1e1e;
  }

  .focus-ring {
    position: absolute;
    left: -5px;
    top: -4px;
    width: 177px;
    height: 218px;
    border: solid 4px #eeeeee;
    z-index: 5;
  }
  .cover-img {
    width: 128px;
    height: 128px;
    margin: 16px 20px 23px;
  }
  .card-text {
    display: inline-block;
    width: 100%;
    height: 19px;
    font-size: 16px;
    text-align: center;
    color: #a0a0a0;
  }
  .name {
    width: 100%;
    height: 19px;
    margin: 0 auto;
    line-height: 19px;
    overflow: hidden;
    white-space: nowrap;
    word-break: keep-all;
  }
}
</style>